const sectors = [
  'Consumer/Personal',
  'Education',
  'Manufacturing and Food processing',
  'Real Estate and Construction',
  'Trade and Commerce',
  'Transport and Communication'
];
export default sectors;
